export const resourceLinks = [
  {
    title: "Fruitful App Resources",
    description: "Open DailyDevo’s dedicated Fruitful app resources page for devotionals, guides, and next steps.",
    url: "https://dailydevo.ca/fruitful-app-resources/",
  },
];